import { AxiosInstance } from 'axios';

import {
  AuthBaseConfig,
  ChangePasswordPayload,
  ChangePasswordResponse,
  CompaniesMeResponse,
  ConfigResponse,
  CreateAccountPayload,
  CreateAccountResponse,
  ForgotPasswordPayload,
  ForgotPasswordResponse,
  GetNotificationsMeResponse,
  LoginPayload,
  LoginResponse,
  MeResponse,
  ResetPasswordPayload,
  ResetPasswordResponse
} from './Interfaces/IAuthService';
import { ServiceBaseConfig } from './Interfaces/IAccountService';

export class AuthService {
  public static async create(api: AxiosInstance, payload: CreateAccountPayload): Promise<CreateAccountResponse> {
    try {
      const { data } = await api.post('/register', payload);
      return data;
    } catch (error) {
      console.error('Error in AuthService.create:', error);
      throw error; // Lançar o erro para que ele possa ser tratado no componente
    }
  }

  public static async login(api: AxiosInstance, payload: LoginPayload): Promise<LoginResponse> {
    try {
      const { data } = await api.post('/login', payload);
      return data;
    } catch (error) {
      console.error('Error in AuthService.login:', error);
      throw error;
    }
  }

  public static async forgotPassword(
    api: AxiosInstance,
    payload: ForgotPasswordPayload,
    config: AuthBaseConfig
  ): Promise<ForgotPasswordResponse> {
    try {
      const { data } = await api.post('/forgot-password', payload, config);
      return data;
    } catch (error) {
      console.error('Error in AuthService.forgot-password:', error);
      throw error;
    }
  }

  public static async changePassword(
    api: AxiosInstance,
    payload: ChangePasswordPayload,
    config: AuthBaseConfig
  ): Promise<ChangePasswordResponse> {
    try {
      const { data } = await api.post('/password-reset', payload, config);
      return data;
    } catch (error) {
      console.error('Error in AuthService.password-reset:', error);
      throw error;
    }
  }

  public static async resetPassword(
    api: AxiosInstance,
    payload: ResetPasswordPayload,
    config: AuthBaseConfig
  ): Promise<ResetPasswordResponse> {
    try {
      const { data } = await api.post('/reset-password', payload, config);
      return data;
    } catch (error) {
      console.error('Error in AuthService.password-reset:', error);
      throw error;
    }
  }

  public static async me(api: AxiosInstance, config: ServiceBaseConfig): Promise<MeResponse> {
    try {
      const { data } = await api.get('/users/me', config);
      return data;
    } catch (error) {
      console.error('Error in AuthService.user.me:', error);
      throw error;
    }
  }

  public static async companiesMe(api: AxiosInstance, config: ServiceBaseConfig): Promise<CompaniesMeResponse> {
    try {
      const { data } = await api.get('/companies/my', config);
      return data;
    } catch (error) {
      console.error('Error in AuthService.companies.my:', error);
      throw error;
    }
  }

  public static async allCompanies(api: AxiosInstance, config: ServiceBaseConfig): Promise<CompaniesMeResponse> {
    try {
      const { data } = await api.get('/users/me/companies', config);
      return data;
    } catch (error) {
      console.error('Error in AuthService.users.me.companies:', error);
      throw error;
    }
  }

  public static async getConfigs(api: AxiosInstance, config: ServiceBaseConfig): Promise<ConfigResponse> {
    try {
      const { data } = await api.get('/configs', config);
      return data;
    } catch (error) {
      console.error('Error in AuthService.configs:', error);
      throw error;
    }
  }

  public static async getNotificationsMe(
    api: AxiosInstance,
    config: ServiceBaseConfig
  ): Promise<GetNotificationsMeResponse> {
    try {
      const { data } = await api.get('/users/notifications', config);
      return data;
    } catch (error) {
      console.error('Error in AuthService.users.notifications:', error);
      throw error;
    }
  }

  public static async markNotificationsAsRead(api: AxiosInstance, payload: any, config: any): Promise<any> {
    try {
      const { data } = await api.post('/users/notifications', payload, config);
      return data;
    } catch (error) {
      console.error('Error in AuthService.users.notifications:', error);
      throw error;
    }
  }
}
